export enum Settings {
  FONT_SIZE_SMALL,
  FONT_SIZE_MEDIUM,
  FONT_SIZE_LARGE,
  TRANSCRIPT_TOGGLE,
  CAPTION_TOGGLE,
  BLACK_BOX_TOGGLE,
}
